import './AboutPage.css';

export default function AboutPage() {
  return (
    <div className="about-page">
      <section className="about-page__header section section--dark">
        <div className="container">
          <h1 className="about-page__title staatliches-regular">
            À propos
          </h1>
        </div>
      </section>

      <section className="about-page__content section">
        <div className="container about-page__container">
          <p className="chiron-goround-tc-body">
            Champions Collective a été créé dans le but de permettre aux nouveaux joueurs de progresser dans un environnement ressemblant à celui de la compétition officielle Pokémon (VGC), mais plus accessible, en étant une passerelle pour la plateforme de tournois en ligne Limitless, tout en proposant son propre mini-circuit virtuel.
          </p>

          <h2 className="about-page__section-title staatliches-regular">Contexte</h2>
          <p className="chiron-goround-tc-body">
            Pokémon Champions a permis une meilleure accessibilité à la compétition Pokémon. En revanche, un travail restait à faire concernant la participation aux tournois. Le jeu propose gratuitement un système de combat classés qui ne ressemble pas à l'expérience proposée en compétition officielle en présentiel, qui elle présente de nombreux inconvénients, surtout quand on débute : majors à 70€, sans compter les dépenses pour se déplacer et dormir sur place, potentiellement devoir poser sa journée (ou deux), pas de garantie d'obtenir son ticket face à la forte demande, et enfin, des tournois locaux pas souvent accessibles selon notre lieu de vie.
          </p>
          <p className="chiron-goround-tc-body">
            La plateforme Limitless propose de nombreux tournois en ligne, organisés par la communauté, reflétant mieux l'expérience de tournoi, ce qui est idéal pour progresser.
          </p>
          <p className="chiron-goround-tc-body">
            Champions Collective se veut être un pont entre la nouvelle vague de joueurs Pokémon Champions francophones, ne connaissant pas forcément Limitless et ses tournois, tout en proposant un circuit, une série de tournois où les meilleurs joueurs remportent des points leur permettant une participation à un tournoi Invitational.
          </p>

          <h2 className="about-page__section-title staatliches-regular">La raison de ce circuit</h2>
          <p className="chiron-goround-tc-body">
            Ce circuit ne propose pas de cashprize mais est 100% gratuit. Sa raison d'exister est simple : Nous croyons en l'idée d'encourager des joueurs à continuer ces tournois de manière régulière, avec un système qualificatif représentant un objectif à atteindre, afin de les pousser à chercher à progresser.
          </p>
          <p className="chiron-goround-tc-body">
            La plupart des joueurs VGC utilisent les tournois organisés sur Limitless pour s'entrainer avant un major. D'autres y participent car ils ne peuvent pas jouer de major. Un environnement accessible et propice à la progression est le meilleur moyen de profiter de Pokémon Champions.
          </p>

          <h2 className="about-page__section-title staatliches-regular">Nous rejoindre</h2>

          <h3 className="about-page__subsection-title staatliches-regular">Mettre en valeur son tournoi</h3>
          <p className="chiron-goround-tc-body">
            Champions Collective permet à des organisateurs de mettre en valeur son tournoi, même s'il ne fait pas partie de notre circuit.
          </p>

          <h3 className="about-page__subsection-title staatliches-regular">Intégrer ses tournois dans notre circuit</h3>
          <p className="chiron-goround-tc-body">
            Nous ne garantissons rien concernant ce genre de partenariat, mais nous sommes ouvert à toute proposition. Les tournois devront idéalement être organisés par l'organisation Champions Collective FR sur Limitless pour faciliter le calcul de points automatique.
          </p>
          <p className="chiron-goround-tc-body">
            Si vous souhaitez financer le circuit pour proposer un cashprize, nous ne souhaitons pas en être responsable pour le moment. Mais nous restons ouvert à toute proposition, tant que vous vous garantissez garant de ce financement et responsable des transactions à appliquer.
          </p>

          <p className="about-page__contact chiron-goround-tc-body">
            Pour nous contacter, envoyez un mail à{' '}
            <a href="mailto:championscollective@protonmail.com" className="about-page__contact-link">
              championscollective@protonmail.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
